module.exports = __webpack_public_path__ + "static/media/email.c689d6e0.svg";